<template>
  <v-container grid-list-md>
    <div class="pageTitle">月次集計管理</div>
    <v-expansion-panel v-model="panel" expand style="margin: 10px 0px">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="title">表示条件</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">年月</v-flex>
              <v-flex md2>
                <v-select :items="years" v-model="year" suffix="年" />
              </v-flex>
              <v-flex md1>
                <v-select :items="months" v-model="month" suffix="月" />
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">スタッフ</v-flex>
              <v-flex md8>
                <v-autocomplete
                  v-model="selectedStaffs"
                  :items="staffs"
                  chips
                  item-text="name"
                  item-value="name"
                  multiple
                  :menu-props="{ auto: true, overflowY: true }"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md2>
                <v-btn @click="clearSelectedStaffs">
                  <v-icon>backspace</v-icon>クリア
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">チーム</v-flex>
              <v-flex md2 v-for="(team, i) in teams" :key="i">
                <v-checkbox
                  v-model="selectedTeams"
                  :label="team"
                  :value="team"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading"
                >フリーワード *</v-flex
              >
              <v-flex md4>
                <v-text-field v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-btn color="green" class="white--text" @click="downloadUsersFile">
      <v-icon color="white">cloud_download</v-icon>月次データ
    </v-btn>
    <v-btn
      color="green"
      class="white--text"
      @click="downloadHomeWorkDayCountFile"
    >
      <v-icon color="white">cloud_download</v-icon>在宅データ
    </v-btn>

    <v-layout style="height: 500px; width: 100%">
      <div class="table-container scroll-bar">
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          class="elevation-1"
          :search="search"
          :pagination.sync="pagination"
          rows-per-page-text="表示行"
          :rows-per-page-items="rowsPerPageItems"
          style="width: 3300px"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="{ sticky: true, 'column-fixed': header.text == '日' }"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr @click="toTimesheet(props.item)">
              <td class="text-xs-left">{{ props.item.workType }}</td>
              <td class="text-xs-left">{{ props.item.staffNo }}</td>
              <td class="text-xs-left">{{ props.item.staffName }}</td>
              <td class="text-xs-left">{{ props.item.status }}</td>
              <td>{{ props.item.workingDays }}</td>
              <td>{{ props.item.workingHours }}</td>
              <td>{{ props.item.absenceDays }}</td>
              <td>{{ props.item.workingHolidayDays }}</td>
              <td>{{ props.item.paidDaysOff }}</td>
              <td>{{ props.item.mDays }}</td>
              <td>{{ props.item.overtimeHours }}</td>
              <td>{{ props.item.lateNightHours }}</td>
              <td>{{ props.item.holidayWorkingHours }}</td>
              <td>{{ props.item.holidayWorkingLateNightHours }}</td>
              <td>{{ props.item.lackHours }}</td>
              <td>{{ props.item.otherPaymentAmount }}</td>
              <td>{{ props.item.commutingAllowance }}</td>
              <td>{{ props.item.predefinedTime }}</td>
              <td>{{ props.item.paidDaysLeft }}</td>
              <td>{{ props.item.baseSalary }}</td>
              <td>{{ props.item.overtimeMoney }}</td>
              <td>{{ props.item.holidayMoney }}</td>
              <td>{{ props.item.lateNightMoney }}</td>
              <td>{{ props.item.lateNightMoneyOnWorkday }}</td>
              <td>{{ props.item.lateNightMoneyOnHoliday }}</td>
              <td>{{ props.item.deficitMoney }}</td>
              <td>{{ props.item.overtimeWithinLawHours }}</td>
              <td>{{ props.item.overtimeByLawHours }}</td>
              <td>{{ props.item.roudou }}</td>
              <td>{{ props.item.kenko_insurance }}</td>
              <td>{{ props.item.kouseinenkin_insurance }}</td>
              <td>{{ props.item.subtotalInsurance }}</td>
              <td>{{ props.item.homeWork }}</td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.itemsLength }} 件中 {{ props.pageStart }} -
            {{ props.pageStop }} 件表示</template
          >
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import ReadTimecard from "@/components/ManageAttendance/readTimecard.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { getMoment, unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import XLSX from "xlsx";
import { calcWorkingHoursWithinLaw } from "@/utils/timeCount.js";
import { teamsArray } from "@/master/users.js";

export default {
  components: {
    ReadTimecard,
  },
  data() {
    return {
      dbRef: db.collection("timesheets"),
      dialog: false,
      panel: [true],
      selectedStaffs: [],
      staffs: [],
      year: 2020,
      month: 1,
      dates: [],
      timecards: [],
      items: [],
      years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      teams: teamsArray,
      selectedTeams: [],
      selectedTimecard: {},
      headers: [
        { text: "種別​ *", value: "workType", sortable: false },
        { text: "社員番号 *​", value: "staffNo", sortable: false },
        { text: "名前 *​", value: "staffName", sortable: false },
        { text: "ステータス *", value: "status", sortable: false },
        { text: "要勤務日数", value: "workingDays", sortable: false },
        { text: "平日総労働時間​", value: "workingHours", sortable: false },
        { text: "欠勤日数", value: "absenceDays", sortable: false },
        { text: "休日出勤日数", value: "workingHolidayDays", sortable: false },
        { text: "有給消化日数", value: "paidDaysOff", sortable: false },
        { text: "特別有給消化日数", value: "mDays", sortable: false },
        { text: "超過勤務時間", value: "overtimeHours", sortable: false },
        { text: "平日深夜時間​​", value: "lateNightHours", sortable: false },
        { text: "休日総労働", value: "holidayWorkingHours", sortable: false },
        {
          text: "休日深夜時間",
          value: "holidayWorkingLateNightHours",
          sortable: false,
        },
        { text: "不足時間", value: "lackHours", sortable: false },
        { text: "その他支給", value: "otherPaymentAmount", sortable: false },
        { text: "非課税通勤費", value: "commutingAllowance", sortable: false },
        { text: "所定時間", value: "predefinedTime", sortable: false },
        { text: "有給残日数", value: "paidDaysLeft", sortable: false },
        { text: "基本給", value: "baseSalary", sortable: false },
        { text: "超過勤務手当", value: "overtimeMoney", sortable: false },
        { text: "休日出勤手当", value: "holidayMoney", sortable: false },
        { text: "深夜勤務手当", value: "lateNightMoney", sortable: false },
        { text: "深夜勤務手当（平日）", value: "lateNightMoneyOnWorkday", sortable: false },
        { text: "深夜勤務手当（休日）", value: "lateNightMoneyOnHoliday", sortable: false },
        { text: "不足時間控除", value: "deficitMoney", sortable: false },
        {
          text: "法定内超過時間",
          value: "overtimeWithinLawHours",
          sortable: false,
        },
        {
          text: "法定外超過時間",
          value: "overtimeByLawHours",
          sortable: false,
        },
        { text: "健康保険料​", value: "kenko_insurance", sortable: false },
        {
          text: "厚生年金保険料",
          value: "kouseinenkin_insurance",
          sortable: false,
        },
        { text: "労働保険料", value: "roudou", sortable: false },
        { text: "法定福利小計", value: "subtotalInsurance", sortable: false },
        { text: "在宅時間", value: "homeWork", sortable: false },
      ],
      pagination: {
        rowsPerPage: 50,
      },
      rowsPerPageItems: [25, 50, 100, 500],
      search: "",
      tableItems: [],
    };
  },
  created() {
    const today = getMoment()();
    this.month = today.month() + 1;
    this.year = today.year();
  },
  mounted() {
    this.fixHeaders();
    this.reloadStaffs();
  },
  computed: {
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    filteredItems() {
      return this.tableItems.filter((item) => {
        return (
          (this.selectedTeams.includes(item.team) &&
            this.selectedStaffs.length == 0) ||
          this.selectedStaffs.includes(item.staffName)
        );
      }, this);
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapState("auth", ["authorities"]),
  },
  watch: {
    month() {
      this.reloadItems();
    },
  },
  methods: {
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      elms[0].style.overflow = "visible";
    },
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    clearSelectedStaffs() {
      this.selectedStaffs = [];
    },
    async reloadStaffs() {
      this.changeLoadingState(true);
      this.staffs = [];
      try {
        const staffs = await db.collection("users").get();
        staffs.forEach((doc) => {
          this.staffs.push({ ...doc.data(), id: doc.id });
        });
      } finally {
        this.changeLoadingState(false);
      }
    },
    async reloadItems() {
      this.changeLoadingState(true);
      this.tableItems = [];
      const items = await this.dbRef
        .where("month_id", "==", this.month_id)
        .where("version", ">=", 2)
        .get();
      this.items = [];
      items.forEach((doc) => {
        const item = doc.data();
        // if (item.status != "入力中") {
        this.items.push({ ...item, id: doc.id });
        this.addToTableItems(item);
        // }
      });
      this.tableItems = this.tableItems.sort(function (a, b) {
        if (a.team != b.team) {
          const getTeamComparePoint = function (item) {
            const teamCompareTable = { 経理: 1, 給与: 2, サポート: 3 };
            return teamCompareTable[item] ? teamCompareTable[item] : 0;
          };
          return getTeamComparePoint(a.team) - getTeamComparePoint(b.team);
        } else if (a.workType != b.workType) {
          const getwokTypePoint = function (item) {
            const workTypeCompareTable = { 一般: 1, 時給: 2, アルバイト: 3 };
            return workTypeCompareTable[item] ? workTypeCompareTable[item] : 0;
          };
          return getwokTypePoint(a.workType) - getwokTypePoint(b.workType);
        } else {
          return (
            (Number(a.staffNo) ? Number(a.staffNo) : 0) -
            (Number(b.staffNo) ? Number(b.staffNo) : 0)
          );
        }
      });
      this.changeLoadingState(false);
    },
    addToTableItems(item) {
      const tableItem = {};
      tableItem.userId = item.user_id;
      tableItem.staffNo = item.staff_id;
      tableItem.team = item.team_name;
      tableItem.status = item.status;
      tableItem.staffName = item.user_name;
      tableItem.workType = item.work_type;
      tableItem.paidDaysOff =
        item.counts.date.paidDayOff;
      tableItem.mDays = item.counts.date.mDay;
      tableItem.otherPaymentAmount =
        item.counts.money.sumTravelExpenses +
        item.counts.money.sumOtherExpenses;
      tableItem.predefinedTime = unixtimeToFormattedLargeTime(
        item.counts.time.monthly_predefined
      );

      tableItem.homeWork = item.counts.time.homeWork
        ? unixtimeToFormattedLargeTime(item.counts.time.homeWork)
        : "未集計";
      tableItem.paidDaysLeft =
        item.paid_days_off_count || item.paid_days_off_count == 0
          ? item.paid_days_off_count
          : "未集計";

      tableItem.roudou = item.counts.money.roudou || 0;
      tableItem.kenko_insurance = item.counts.money.kenko_insurance || 0;
      tableItem.kouseinenkin_insurance =
        item.counts.money.kouseinenkin_insurance || 0;
      tableItem.subtotalInsurance = item.counts.money.subtotalInsurance || 0;
      if (tableItem.workType == "一般") {
        tableItem.workingDays = item.counts.date.regularWorkDay;
        tableItem.workingHours = unixtimeToFormattedLargeTime(
          item.counts.time.work
        );
        tableItem.absenceDays = item.counts.date.absence;
        tableItem.workingHolidayDays = item.counts.date.holidayWorkingDay;
        tableItem.overtimeHours =
          item.counts.time.diffrence_monthly_predefined_and_work > 0
            ? unixtimeToFormattedLargeTime(0)
            : unixtimeToFormattedLargeTime(
                -1 * item.counts.time.diffrence_monthly_predefined_and_work
              );
        tableItem.lateNightHours = unixtimeToFormattedLargeTime(
          item.counts.time.lateNight
        );
        tableItem.holidayWorkingHours = unixtimeToFormattedLargeTime(
          item.counts.time.holidayWork
        );
        tableItem.holidayWorkingLateNightHours = unixtimeToFormattedLargeTime(
          item.counts.time.holidayLateNight
        );
        if (item.counts.time.diffrence_monthly_predefined_and_work < 0) {
          tableItem.overtimeHours = unixtimeToFormattedLargeTime(
            -1 * item.counts.time.diffrence_monthly_predefined_and_work
          );
          tableItem.lackHours = unixtimeToFormattedLargeTime(0);
        } else {
          tableItem.lackHours = unixtimeToFormattedLargeTime(
            item.counts.time.diffrence_monthly_predefined_and_work
          );
          tableItem.overtimeHours = unixtimeToFormattedLargeTime(0);
        }

        tableItem.commutingAllowance = item.counts.money.commuting_allowance;
        tableItem.baseSalary = item.counts.money.base_salary;
        tableItem.overtimeMoney = item.counts.money.overtime;
        tableItem.holidayMoney = item.counts.money.holiday;
        tableItem.lateNightMoney = item.counts.money.late_night;
        tableItem.lateNightMoneyOnHoliday = item.counts.money.late_night_on_holiday;
        tableItem.lateNightMoneyOnWorkday = item.counts.money.late_night_on_workday;
        tableItem.deficitMoney = item.counts.money.deficit;
        if (item.owner.few_work_days) {
          tableItem.overtimeByLawHours = unixtimeToFormattedLargeTime(
            item.counts.time.overtime_by_law
          );
          tableItem.overtimeWithinLawHours = unixtimeToFormattedLargeTime(
            calcWorkingHoursWithinLaw(item.counts.time)
          );
        } else {
          tableItem.overtimeByLawHours = tableItem.overtimeHours;
          tableItem.overtimeWithinLawHours = unixtimeToFormattedLargeTime(0);
        }
      } else if (tableItem.workType == "時給") {
        tableItem.workingDays = Math.floor(item.counts.date.workingDay);
        tableItem.workingHours = unixtimeToFormattedLargeTime(
          item.counts.time.work +
            item.counts.time.holidayWork +
            item.counts.time.paidDayOff -
            item.counts.time.overtime
        );
        tableItem.absenceDays = 0;
        tableItem.workingHolidayDays = 0;
        tableItem.overtimeHours = unixtimeToFormattedLargeTime(
          item.counts.time.overtime
        );
        tableItem.lateNightHours = unixtimeToFormattedLargeTime(
          item.counts.time.lateNight + item.counts.time.holidayLateNight
        );
        tableItem.holidayWorkingHours = unixtimeToFormattedLargeTime(0);
        tableItem.holidayWorkingLateNightHours =
          unixtimeToFormattedLargeTime(0);
        tableItem.lackHours = unixtimeToFormattedLargeTime(0);

        tableItem.commutingAllowance = item.counts.money.commuting_allowance;
        tableItem.baseSalary = item.counts.money.base_salary;
        tableItem.overtimeMoney = item.counts.money.overtime;
        tableItem.holidayMoney = 0;
        tableItem.lateNightMoney = item.counts.money.late_night;
        tableItem.lateNightMoneyOnHoliday = item.counts.money.late_night_on_holiday;
        tableItem.lateNightMoneyOnWorkday = item.counts.money.late_night_on_workday;
        tableItem.deficitMoney = 0;
        tableItem.overtimeByLawHours = tableItem.overtimeHours;
        tableItem.overtimeWithinLawHours = unixtimeToFormattedLargeTime(0);
      } else if (tableItem.workType == "アルバイト") {
        tableItem.workingDays = item.counts.date.workingDay;
        tableItem.workingHours = unixtimeToFormattedLargeTime(
          item.counts.time.work +
            item.counts.time.holidayWork +
            item.counts.time.paidDayOff -
            item.counts.time.overtime
        );
        tableItem.absenceDays = 0;
        tableItem.workingHolidayDays = 0;
        tableItem.overtimeHours = unixtimeToFormattedLargeTime(
          item.counts.time.overtime
        );
        tableItem.lateNightHours = unixtimeToFormattedLargeTime(
          item.counts.time.lateNight + item.counts.time.holidayLateNight
        );
        tableItem.holidayWorkingHours = unixtimeToFormattedLargeTime(0);
        tableItem.holidayWorkingLateNightHours =
          unixtimeToFormattedLargeTime(0);
        tableItem.lackHours = unixtimeToFormattedLargeTime(0);

        tableItem.commutingAllowance = item.counts.money.commuting_allowance;
        tableItem.baseSalary = item.counts.money.base_salary;
        tableItem.overtimeMoney = item.counts.money.overtime;
        tableItem.holidayMoney = 0;
        tableItem.lateNightMoney = item.counts.money.late_night;
        tableItem.lateNightMoneyOnHoliday = item.counts.money.late_night_on_holiday;
        tableItem.lateNightMoneyOnWorkday = item.counts.money.late_night_on_workday;
        tableItem.deficitMoney = 0;
        tableItem.overtimeByLawHours = tableItem.overtimeHours;
        tableItem.overtimeWithinLawHours = unixtimeToFormattedLargeTime(0);
      }

      this.tableItems.push(tableItem);
    },
    prvMonth() {
      this.month = this.month - 1;
    },
    nextMonth() {
      this.month = this.month + 1;
    },
    getTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    toTimesheet(item) {
      const route = this.$router.resolve({
        name: "home",
        params: { user_id: item.userId },
        query: { year: this.year, month: this.month },
      });
      window.open(route.href, "_blank");
    },
    downloadUsersFile() {
      var FileSaver = require("file-saver");
      var workbook = { SheetNames: [], Sheets: {} };
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      const header = [];
      const keys = [];
      const tableData = [];
      this.headers.forEach((h) => {
        header.push(h.text);
        keys.push(h.value);
      });
      tableData.push(header);
      this.tableItems.forEach((item) => {
        const row = [];
        keys.forEach((k) => {
          row.push(item[k]);
        });
        tableData.push(row);
      });
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(tableData),
        "timeTables"
      );

      var wbout = XLSX.write(workbook, wopts);
      var blob = new Blob([wbout], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "timetables.xlsx");
    },
    downloadHomeWorkDayCountFile() {
      console.log(this.items[0]);
      this.items.forEach((item) => {
        console.log(
          item.user_id,
          item.team_name,
          item.counts.date.homeWorkDay ? item.counts.date.homeWorkDay : null
        );
      });

      var FileSaver = require("file-saver");
      var workbook = { SheetNames: [], Sheets: {} };
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      const header = ["user_id", "チーム", "在宅日"];
      const tableData = [];

      tableData.push(header);

      this.items.forEach((item) => {
        tableData.push([
          item.user_id,
          item.team_name,
          item.counts.date.homeWorkDay ? item.counts.date.homeWorkDay : null,
        ]);
      });
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(tableData),
        "homeWorkDayCount"
      );

      var wbout = XLSX.write(workbook, wopts);
      var blob = new Blob([wbout], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "homeWorkDayCount.xlsx");
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
};
</script>

<style lang="css" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
td.text-smaller {
  font-size: 0.8em;
}
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
</style>